export default __webpack_public_path__ + "static/media/search-bar.70ababfa.svg";